import React, { PureComponent } from 'react'
import {
  Col,
  FormGroup,
  Input,
  Label,
  Card,
  CardHeader,
  CardBody,
  Button
} from 'reactstrap'
import axios from 'axios'
import Alert from '../../Widgets/Alert'
import withAlertTimeout from '../../../HOCs/withAlertTimeout'

const decodeEntities = (function() {
  // this prevents any overhead from creating the object each time
  const element = document.createElement('div')

  function decodeHTMLEntities(str) {
    if (str && typeof str === 'string') {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '')
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '')
      element.innerHTML = str
      str = element.textContent
      element.textContent = ''
    }

    return str
  }

  return decodeHTMLEntities
})()

class EditCategory extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isUpdatingCategory: false,
      selectedCategoryId: null,
      selectedCategoryName: null,
      updatedCategoryName: null
    }
    this.updateCategory = this.updateCategory.bind(this)
    this.onCategorySelect = this.onCategorySelect.bind(this)
    this.onUpdateCategoryName = this.onUpdateCategoryName.bind(this)
  }

  renderCategories() {
    return this.props.categories.map(cat => (
      <option key={cat.id} value={cat.id} onChange={this.onCategorySelect}>
        {cat.categoryName}
      </option>
    ))
  }

  onUpdateCategoryName(e) {
    this.setState({ updatedCategoryName: e.target.value })
  }

  updateCategory() {
    if (this.state.updatedCategoryName) {
      const token = sessionStorage.getItem('token')
      const headers = { Authorization: `Bearer ${token}` }
      this.setState({ isUpdatingCategory: true })
      axios
        .put(
          `/api/proxy/v2/categories/${this.state.selectedCategoryId}`,
          { categoryName: this.state.updatedCategoryName },
          { headers }
        )
        .then(({ data }) => {
          this.setState({
            selectedCategoryId: null,
            selectedCategoryName: null,
            updatedCategoryName: null,
            isUpdatingCategory: false
          })
          this.props.showSuccess()
          this.props.refresh()
        })
        .catch(err => {
          console.log(err)
          this.setState({ isUpdatingCategory: false })
          this.props.showFailure()
        })
    }
  }

  onCategorySelect(e) {
    const selection = e.target.selectedOptions[0]
    this.setState({
      selectedCategoryId: selection.value,
      selectedCategoryName: selection.innerHTML,
      updatedCategoryName: decodeEntities(selection.innerHTML)
    })
  }

  render() {
    return (
      <Card>
        {<Alert active={this.props.success} message="Category Updated" />}
        {
          <Alert
            type="danger"
            active={this.props.failure}
            message="Something went wrong, please try again"
          />
        }
        <CardHeader>Update a Category</CardHeader>
        <CardBody>
          <Col md="6" xs="12">
            <FormGroup>
              <Input
                type="select"
                name="select"
                id="select"
                onChange={this.onCategorySelect}
              >
                <option
                  selected={this.state.updatedCategoryName === null}
                  default
                  value={null}
                >
                  Select a Category to Update
                </option>
                {this.renderCategories()}
              </Input>
            </FormGroup>
            {this.state.selectedCategoryName && (
              <FormGroup>
                <Label htmlFor="category name">Edit Category Name Below</Label>
                <Input
                  type="text"
                  name="name"
                  value={this.state.updatedCategoryName}
                  onChange={this.onUpdateCategoryName}
                />
              </FormGroup>
            )}
            <Button
              style={{ float: 'right' }}
              type="submit"
              color="primary"
              onClick={this.updateCategory}
              disabled={
                this.state.updatedCategoryName ===
                  this.state.selectedCategoryName ||
                !this.state.updatedCategoryName.length
              }
            >
              {this.state.isUpdatingCategory && (
                <i
                  className="fa fa-circle-o-notch fa-spin"
                  style={{ marginRight: 5 }}
                />
              )}
              Submit
            </Button>
          </Col>
        </CardBody>
      </Card>
    )
  }
}

export default withAlertTimeout(EditCategory)



// WEBPACK FOOTER //
// ./src/views/Pages/Categories/EditCategory.js